import { render, staticRenderFns } from "./AddStoreShippingComponent.vue?vue&type=template&id=6280e440&scoped=true"
import script from "./AddStoreShippingComponent.vue?vue&type=script&lang=js"
export * from "./AddStoreShippingComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6280e440",
  null
  
)

export default component.exports